import { RouterLinkOptimised } from '@/components/RouterLinkOptimised';
import { CompanyIcon } from '@/components/CompanyIcon';
import { getNarrativeCommunityTitle } from '../utils';

type Props = {
  uniqueSymbol: string | undefined | null;
  website: string | undefined | null;
  companyName: string | undefined | null;
  companyCanonicalUrl: string | undefined | null;
  narrativeCount: number | undefined | null;
  primaryNarrativeCount: number | undefined | null;
  commentCount: number | undefined | null;
};

export const NarrativeCommunityCompanyHeader = ({
  companyName,
  uniqueSymbol,
  website,
  companyCanonicalUrl,
  narrativeCount,
  primaryNarrativeCount,
  commentCount,
}: Props) => {
  const title = getNarrativeCommunityTitle({
    companyName,
    primaryIndustryLabel: null,
    market: null,
  });
  return (
    <div className="mt-2 grid grid-rows-[repeat(2,min-content)] gap-x2">
      <div className="grid grid-cols-[min-content_1fr] gap-x2">
        <CompanyIcon
          website={website}
          tickerSymbol={uniqueSymbol || ''}
          size={60}
        />
        <div className="grid grid-rows-[min-content_min-content] content-around">
          <h1 className="m-0 text-xl font-bold [word-break:break-word]">
            <RouterLinkOptimised
              to={companyCanonicalUrl || ''}
              className="no-underline [color:inherit] hover:text-soft"
            >
              {title}
            </RouterLinkOptimised>
          </h1>
          <span className="text-xs text-softer">{uniqueSymbol} Community</span>
        </div>
      </div>
      <ul role="list" className="grid grid-cols-[repeat(3,max-content)] gap-x2">
        <li className="text-xs">
          <span className="text-solid">{narrativeCount}</span>
          &nbsp;
          <span className="text-soft">Narratives</span>
          &nbsp;
          <span className="sr-only">written by author</span>
        </li>
        <li className="text-xs">
          <span className="text-solid">{commentCount}</span>
          &nbsp;
          <span className="text-soft">Comments</span>
          &nbsp;
          <span className="sr-only">on narratives written by author</span>
        </li>
        <li className="text-xs">
          <span className="text-solid">{primaryNarrativeCount}</span>
          &nbsp;
          <span className="text-soft">Fair Values set</span>
          &nbsp;
          <span className="sr-only">on narratives written by author</span>
        </li>
      </ul>
    </div>
  );
};
